import { render, staticRenderFns } from "./OrganisationMembers.vue?vue&type=template&id=09d8e6b6&scoped=true&"
import script from "./OrganisationMembers.vue?vue&type=script&lang=js&"
export * from "./OrganisationMembers.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationMembers.vue?vue&type=style&index=0&id=09d8e6b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d8e6b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VDivider})
